module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module2-2.dc5d58e9.png";